<ng-template #guarantee let-small="small">
  <div
    class="inline-flex items-center text-xs font-medium"
    [ngClass]="small ? 'w-auto' : 'px-4 py-2 w-full bg-gray-200 rounded-xl'"
  >
    <app-shield-check-icon class="mr-2" width="20" height="20" />
    {{ small ? '30-day money-back guarantee' : 'We use 3-D Secure to protect your payments' }}.
  </div>
</ng-template>

<section class="px-5 flex justify-center">
  <div class="container mx-0 2xl:mx-auto flex flex-col">
    @if (isLoading) {
      <div class="flex flex-col justify-center items-center h-[80vh]">
        <nz-spin nzSimple nzSize="large"></nz-spin>
        <p class="mt-6 text-gray-500 text-xl">Processing, please wait...</p>
      </div>
    } @else {
      <div class="flex mb-12 flex-col gap-4 text-xs">
        <div class="flex gap-1 items-center text-gray-500 mt-3">
          <span>Payment</span>
          <span nz-icon nzType="right" class="text-[10px]"></span>
          <span class="capitalize">Checkout</span>
        </div>
        <h1 class="text-2xl font-bold">Checkout</h1>
      </div>

      <div class="flex mt-6 lg:mt-0 flex-col-reverse gap-16 lg:flex-row lg:justify-between">
        <div class="flex flex-col gap-6 w-full lg:w-3/5">
          @if (!user && !savedUser) {
            <div class="flex flex-col gap-6 w-full">
              <h3 class="text-lg font-light">1. Personal information</h3>
              <lib-payment-auth (personalInfo)="onPersonalInfo($event)"></lib-payment-auth>
            </div>
          }

          @if (!isManualInput) {
            <div
              class="flex flex-col gap-6"
              [ngClass]="{ 'opacity-50 pointer-events-none': !user?.id && !personalInfo?.email && !referenceNumber }"
            >
              <h3 class="text-lg font-light">
                {{ user && user.id ? '1.' : '2.' }} Select currency (Optional)
              </h3>
              <div class="flex bg-white items-center justify-between rounded-xl border px-6 py-3">
                <div class="flex flex-col gap-2 w-3/5">
                  <p class="text-sm font-medium">Change currency?</p>
                  <span class="text-xs opacity-75">In case you want to change the currency</span>
                </div>
                <nz-select
                  class="w-2/5"
                  [ngModel]="selectedCurrencyId"
                  (ngModelChange)="selectCurrency($event)"
                  nzPlaceHolder="{{ currencyCode(summaryData.currency) }}"
                >
                  @for (item of availableCurrencies; track item.currencyId) {
                    <nz-option [nzValue]="item.currencyId" [nzLabel]="currencyCode(item.currency)"></nz-option>
                  }
                </nz-select>
              </div>
            </div>
          }

          <div
            class="flex flex-col gap-6"
            [ngClass]="{ 'opacity-50 pointer-events-none': !user?.id && !personalInfo?.email && !referenceNumber }"
          >
            <h3 class="text-lg font-light">
              {{ user && user.id && isManualInput ? '' : (user && user.id && !isManualInput) || !user ? '2.' : '3.' }}
              Select payment method
            </h3>

            <div class="flex flex-col gap-4 w-full">
              <div
                class="flex flex-col bg-white rounded-xl px-6 py-6 border transition-all"
                [ngClass]="selectedPaymentSection === 'MASTERCARD' ? 'border-main-color' : 'border-gray-300 hover:border-main-color'"
              >
                <div
                  class="flex items-center justify-between cursor-pointer"
                  role="button"
                  tabindex="0"
                  (click)="togglePaymentOption('MASTERCARD')"
                  (keyup.enter)="togglePaymentOption('MASTERCARD')"
                >
                  <div class="flex gap-2 items-center">
                    <p class="text-sm">Visa & Mastercard</p>
                    <img src="/images/visa_icon.svg" class="h-5 w-auto" alt="Visa" />
                    <img src="/images/mastercard_icon.svg" class="h-5 w-auto" alt="Mastercard" />
                  </div>
                  <span
                    nz-icon
                    nzType="down"
                    class="transition-all"
                    [ngClass]="{ 'rotate-180': selectedPaymentSection === 'MASTERCARD' }"
                  ></span>
                </div>
                @if (selectedPaymentSection === 'MASTERCARD' && paymentConfig) {
                  <lib-mastercard
                    [payloadConfig]="paymentConfig"
                    (paymentSubmitted)="onPaymentSubmitted()"
                  ></lib-mastercard>
                }
              </div>

              <div
                class="flex flex-col bg-white rounded-xl px-6 py-6 border transition-all"
                [ngClass]="selectedPaymentSection === 'ZIMSWITCH' ? 'border-main-color' : 'border-gray-300 hover:border-main-color'"
              >
                <div
                  class="flex items-center justify-between cursor-pointer"
                  role="button"
                  tabindex="0"
                  (click)="togglePaymentOption('ZIMSWITCH')"
                  (keyup.enter)="togglePaymentOption('ZIMSWITCH')"
                >
                  <div class="flex gap-2 items-center">
                    <p class="text-sm">Zimswitch</p>
                    <img src="/images/card-front.webp" class="h-5 w-auto" alt="Zimswitch" />
                  </div>
                  <span
                    nz-icon
                    nzType="down"
                    class="transition-all"
                    [ngClass]="{ 'rotate-180': selectedPaymentSection === 'ZIMSWITCH' }"
                  ></span>
                </div>
                @if (selectedPaymentSection === 'ZIMSWITCH' && paymentConfig) {
                  <lib-zimswitch [payloadConfig]="paymentConfig"></lib-zimswitch>
                }
              </div>

              <div
                class="flex flex-col bg-white rounded-xl px-6 py-6 border transition-all"
                [ngClass]="selectedPaymentSection === 'ECOCASH' ? 'border-main-color' : 'border-gray-300 hover:border-main-color'"
              >
                <div
                  class="flex items-center justify-between cursor-pointer"
                  role="button"
                  tabindex="0"
                  (click)="togglePaymentOption('ECOCASH')"
                  (keyup.enter)="togglePaymentOption('ECOCASH')"
                >
                  <div class="flex gap-2 items-center">
                    <p class="text-sm">EcoCash</p>
                    <img src="/images/ecocash-logo.png" class="h-5 w-auto" alt="EcoCash" />
                  </div>
                  <span
                    nz-icon
                    nzType="down"
                    class="transition-all"
                    [ngClass]="{ 'rotate-180': selectedPaymentSection === 'ECOCASH' }"
                  ></span>
                </div>
                @if (selectedPaymentSection === 'ECOCASH' && paymentConfig) {
                  <lib-ecocash
                    [payloadConfig]="paymentConfig"
                    (paymentSubmitted)="onPaymentSubmitted()"
                  ></lib-ecocash>
                }
              </div>
            </div>

            <ng-container *ngTemplateOutlet="guarantee; context: { small: false }"></ng-container>
          </div>
        </div>

        <div class="flex flex-col gap-6 w-full lg:w-2/5">
          <div class="flex items-center justify-between">
            <h3 class="text-lg font-light whitespace-nowrap">Summary</h3>
            <ng-container *ngTemplateOutlet="guarantee; context: { small: true }"></ng-container>
          </div>
          <lib-payment-summary
            [isManualInput]="isManualInput"
            [cart]="summaryData"
            [showCouponCode]="true"
            (priceChange)="onPriceChange($event)"
          ></lib-payment-summary>
        </div>
      </div>
    }
  </div>
</section>

<nz-modal
  [nzVisible]="showResultModal"
  [nzFooter]="null"
  [nzClosable]="false"
  [nzMaskClosable]="false"
  nzCentered
>
  <ng-container *nzModalContent>
    @if (checkoutInfo?.transactionStatus === 'COMPLETE') {
      <div class="flex flex-col justify-center items-center gap-4 py-6">
        <img src="/images/check.png" class="h-40" alt="Success" />
        <h3 class="text-2xl font-bold">Payment Successful!</h3>
        <p class="text-center text-gray-600">
          Thank you for your payment. A receipt has been sent to your registered email.
        </p>
      </div>
    } @else if (checkoutInfo?.transactionStatus === 'FAILED') {
      <div class="flex flex-col justify-center items-center gap-4 py-6">
        <img src="/images/error.png" class="h-40" alt="Failed" />
        <h3 class="text-2xl font-bold">Payment failed!</h3>
        <p class="text-center text-gray-600">
          Something went wrong with payment. Consider trying another card or method.
        </p>
        <button nz-button nzSize="large" nzType="primary" (click)="tryAgain()">Try again</button>
      </div>
    }
  </ng-container>
</nz-modal>

